import * as API from '../api'
export const FETCH_MEDICATION_TYPE = 'FETCH_MEDICATION_TYPE'
export const FETCHING_MEDICATION_TYPE = 'FETCHING_MEDICATION_TYPE'
export const FETCH_MEDICATION_TYPE_ERROR = 'FETCH_MEDICATION_TYPE_ERROR'
export const FETCH_MEDICATIONS_TYPES = 'FETCH_MEDICATIONS_TYPES'
export const FETCHING_MEDICATIONS_TYPES = 'FETCHING_MEDICATIONS_TYPES'
export const FETCH_MEDICATIONS_TYPES_ERROR = 'FETCH_MEDICATIONS_TYPES_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_MEDICATION_TYPE = 'CHANGE_MEDICATION_TYPE'
export const DELETE_MEDICATION_TYPE = 'DELETE_MEDICATION_TYPE'
export const ADD_MEDICATION_TYPE = 'ADD_MEDICATION_TYPE'
export const EDIT_MEDICATION_TYPE = 'EDIT_MEDICATION_TYPE'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_MEDICATION_TYPE = 'NEW_FORM_MEDICATION_TYPE'
export const MEDICATION_TYPE_FORM_ERROR = 'MEDICATION_TYPE_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeMedicationType = medicationType => {
  return dispatch => {
    dispatch({ type: CHANGE_MEDICATION_TYPE, medicationType })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const handleMedicationTypeError = (res, dispatch) => {
  const { data: errorMessage = '' } = res
  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: MEDICATION_TYPE_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormMedicationType = medicationType => {
  return dispatch => {
    dispatch({ type: NEW_FORM_MEDICATION_TYPE })
  }
}

export const setMedicationTypeFormTouched = medicationType => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreMedicationType = id => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS_TYPES })
    return API.medicationsTypes
      .restoreMedicationType(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_MEDICATION_TYPE, medicationType: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_TYPES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleMedicationTypeError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchMedicationsTypes = options => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS_TYPES })
    return API.medicationsTypes
      .getMedicationsTypes(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_MEDICATIONS_TYPES,
          medicationsTypes: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_TYPES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const deleteMedicationType = id => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS_TYPES })
    return API.medicationsTypes
      .deleteMedicationType(id)
      .then(response => {
        const { data = {} } = response
        dispatch({ type: DELETE_MEDICATION_TYPE, medicationType: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_TYPES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addMedicationType = medicationType => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS_TYPES })
    dispatch({ type: FETCHING_MEDICATION_TYPE })
    return API.medicationsTypes
      .addMedicationType(medicationType)
      .then(({ data }) => {
        dispatch({ type: ADD_MEDICATION_TYPE, medicationType: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleMedicationTypeError(response, dispatch)
        dispatch({
          type: FETCH_MEDICATIONS_TYPES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editMedicationType = medicationType => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATIONS_TYPES })
    dispatch({ type: FETCHING_MEDICATION_TYPE })
    return API.medicationsTypes
      .editMedicationType(medicationType)
      .then(({ data }) => {
        dispatch({ type: EDIT_MEDICATION_TYPE, medicationType: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATIONS_TYPES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleMedicationTypeError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchMedicationType = id => {
  return dispatch => {
    dispatch({ type: FETCHING_MEDICATION_TYPE, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.medicationsTypes
      .getMedicationType(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_MEDICATION_TYPE, medicationType: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_MEDICATION_TYPE_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/medicationsTypes.js